export interface IUpdateInsuranceDataRequest {
    id: number,
    list: number[]
}